exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-content[data-v-020ef222]{margin-bottom:70px}.buyFixBar[data-v-020ef222]{background-color:#fff;width:100%;padding:20px;height:60px;position:fixed;left:0;right:0;bottom:0;z-index:9;box-shadow:0 -2px 12px 0 hsla(0,0%,88%,.5)}.left-text-content .el-collapse-item__content[data-v-020ef222]{font-size:14px}.good-format-list[data-v-020ef222]{float:left;margin-left:10px}", ""]);

// exports
